export * from './acao-log-geral.pipe';
